module.exports = __webpack_public_path__ + "static/media/Group 7011.793e75d4.svg";